import React, { useEffect, useState, useMemo } from 'react';
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Loader from '../commonForm/Loader';
import ViewIcon from "../../assets/images/Icons/view.svg"
import EditIcon from "../../assets/images/Icons/edit.svg"
import DeleteIcon from "../../assets/images/Icons/delete.svg"
import { IoIosChatbubbles, IoIosRefresh } from 'react-icons/io';
import { FaFileAudio } from "react-icons/fa6";
import ChatModal from "./ChatModule/ChatModal";
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { deleteTicket, filterTickets, getTicket, getTickets, updateChatCount, deleteChatCount, updateTicketCriticalStatus } from '../../services/ticket_api';
import { Link, useSearchParams } from 'react-router-dom';
import { format } from 'date-fns';
import useUserStore from '../../../src/store/UserStore.js';
import Swal from 'sweetalert2';
import Pagination from '../commonForm/Pagination.js';
import Call from '../Twilio/Call.js';
import { t } from '../Language/Translator.js';
// import io from 'socket.io-client';
import DatePicker from 'react-datepicker';
import { attachmentURL } from '../../constant/const.js';
import ChatStore from '../../../src/store/ChatStore';

export const TicketList = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [viewTicketID, setViewTicketID] = useState(null);
    const [filteredTickets, setFilteredTickets] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [filteredFormData, setFilteredFormData] = useState(null);
    const [ticketDatas, setticketData] = useState(null);
    const [chatId, setChatId] = useState(null);
    const [searchParams, setSearchParams] = useSearchParams();
    const [sortBy, setSortBy] = useState(null);
    const [order, setOrder] = useState(null);
    const [sortedTickets, setSortedTickets] = useState([]); // For the sorted tickets
    const [isSorted, setIsSorted] = useState(false); // For tracking if sorting has occurred
    const [severity, setSeverity] = useState('');
    const [status, setStatus] = useState('');
    const [loadingTicketId, setLoadingTicketId] = useState(null);

    // Simplifying the representation critical
    //show and hide tickets
    const statusForFilter = searchParams.get('status');
    const severityForFilter = searchParams.get('severity');

    const user_data = useUserStore((state) => state.user);
    const token = user_data;
    const userInfo = useUserStore((state) => state.userInfo);
    const userType = userInfo?.user_type;
   
    const isNotCustomer = !['customer', 'secondary_customer'].includes(userInfo?.user_type);
    const isNotAnalyst = !['analyst'].includes(userInfo.user_type)

    const queryClient = useQueryClient();
    const handleNewMessage = async () => {
        try{
            const audioContext = new (window.AudioContext || window.webkitAudioContext)();
            await audioContext.resume();
            alert('Audio permission granted');
        } catch (error) {
            console.error('Error requesting audio permission:', error);
        }
    };
 
    useEffect(() => {
        if (statusForFilter || severityForFilter) {       
            const FILTER_FORM = document.querySelector('#filterForm');
            const formData = new FormData(FILTER_FORM);
            if (statusForFilter) {
                
                formData.append('status', statusForFilter);
            } else if (severityForFilter) {
                formData.append('severity', severityForFilter);
            }
            setFilteredFormData(Object.fromEntries(formData.entries()));
            mutateFilter(formData);
        }
    }, [statusForFilter, severityForFilter,])


    const toggleModal = (ticketdata) => {
        setIsOpen(!isOpen);
        ChatStore.getState().setchat(isOpen);
        if (ticketdata) {
            const chat_Id = ticketdata.ticketId;
            setChatId(chat_Id);
            setticketData(ticketdata);
            mutateChatCount(chat_Id);
            mutateChats(chat_Id);
        }

    };

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
        if (filteredFormData) {
            const newFormData = new FormData();
            Object.entries(filteredFormData).forEach(([key, value]) => {
                newFormData.append(key, value);
            });
            newFormData.set('page', pageNumber);
            mutateFilter(newFormData);
        }
        else {
            queryClient.invalidateQueries({ queryKey: ['tickets', pageNumber] });
        }
    };

    const handleSort = (field) => {
        // Toggle between ASC and DESC
        const newOrder = order === 'ASC' ? 'DESC' : 'ASC';
        setSortBy(field);
        setOrder(newOrder);
    };

    const { data: ticketData, isLoading, error, refetch, isFetching, isRefetching } = useQuery({ queryKey: ['tickets', currentPage], queryFn: () => !filteredFormData ? getTickets(token, currentPage, sortBy, order) : null, enabled: !filteredFormData, refetchInterval: 1000, refetchIntervalInBackground: true })
    async function deleteTicketalert(ticketID) {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'You want to delete this ticket!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#19C489',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        });

        if(result.isConfirmed){
            try {
                await deleteTicket(token, ticketID);
                // Reapply current filters after deletion
                const existing_filter = document.querySelector('#filterForm');
                const formData = new FormData(existing_filter);
                formData.append('page', currentPage); // Maintain current page
                if (selectedDate) {
                    const date = new Date(selectedDate);
                    const utcDateOnly = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate())).toISOString().split("T")[0];
                    formData.set("timestamp", utcDateOnly);
                }
                const hasSearchField = Array.from(formData.entries()).some(([key, value]) => value !== '' && key !== 'page');
                if (hasSearchField){
                    mutateFilter(formData);
                }

                Swal.fire('Deleted!', 'Your ticket has been deleted.', 'success');
            } catch (error) {
                Swal.fire('Error!', 'Failed to delete ticket.', 'error');
            }
        }
    }

    function handleFiltering(e) {
        e.preventDefault();
       
        const formData = new FormData(e.target);
        if (selectedDate){
            const date = new Date(selectedDate);
            const utcDateOnly = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate())).toISOString().split("T")[0];
            formData.set("timestamp", utcDateOnly);
        }
        formData.append('page', 1);
        setFilteredFormData(Object.fromEntries(formData.entries()));
        console.log();
        mutateFilter(formData);
    }

    function handleClearFilter(e){
        e.preventDefault();
        document.getElementById("filterForm").reset();
        setFilteredTickets(null);
        setFilteredFormData(null);
        setSelectedDate(null);
        setSeverity('');
        setStatus('');
        setCurrentPage(1);
        queryClient.invalidateQueries({ queryKey: ['tickets'] });

    }

    const { mutate: mutateFilter, isPending: isFiltering } = useMutation({
        mutationFn: (formData) => filterTickets(token, formData),
        onSuccess: function (data){
            setFilteredTickets(data);
        },
        onError: function (error){
            toast.error(error.message);
        },
    });

    const { mutate: mutateChatCount, isPending } = useMutation({
        mutationFn: (ID) => updateChatCount(token, ID),
        onSuccess: function (data) {
        },
        onError: function (error) {

        },
    });

    const { mutate: mutateChats } = useMutation({
        mutationFn: (ID) => deleteChatCount(token, ID, userInfo.user_type),
        onSuccess: function (data) {
        },
        onError: function (error) {
            toast.error(error.message);
        },
    });

    //const TicketsToDisplay = isSorted ? sortedTickets : (filteredTickets?.data?.length > 0 ? filteredTickets : ticketData || {data: [] });

    const TicketsToDisplay = useMemo(() => {
        // 1. Priority: Sorted Data
        if (isSorted) return sortedTickets;

        // 2. Priority: Filtered Data (Check if the object/data exists)
        if (filteredTickets?.data) return filteredTickets;

        // 3. Priority: Default Data
        if (ticketData) return ticketData;

        // 4. Fallback: Empty State
        return { data: [] };
    }, [isSorted, sortedTickets, filteredTickets, ticketData]);

    const handleSeverityChange = (e) => {
        setSeverity(e.target.value);
    };
    const handleStatusChange = (e) => {
        setStatus(e.target.value);
    };


    const toggleCritical = async (ticketId, currentIsCritical) => {
    const newStatus = !currentIsCritical; // Invert the current DB state
    if (loadingTicketId === ticketId) return; 


    const updatedTickets = TicketsToDisplay.data.map(ticket => 
        ticket.ticket_uuid === ticketId 
            ? { ...ticket, isCritical: newStatus } 
            : ticket
    );

    if (filteredTickets) {
        setFilteredTickets(prev => ({
            ...prev,
            data : updatedTickets
        }));
    } else{
        setSortedTickets(updatedTickets);
    }
    setLoadingTicketId(ticketId); 
    try {
        await updateTicketCriticalStatus(token, ticketId, newStatus);
        toast.success(`Ticket marked as ${newStatus ? 'Deception AI mode active.' : 'Deception AI mode inactive.'}`);
    } catch (error) {
        toast.error('Failed to update critical status.');
        setFilteredTickets(filteredTickets); 
    } finally {
        setLoadingTicketId(null); // Reset loading
    }
};

    return(
        <>
            <ToastContainer
                position="top-right" // You can change this to other positions like "bottom-left", "top-center", etc.
                autoClose={5000}    // Duration for which the toast will be visible
                hideProgressBar={true} // Optionally hide the progress bar
                closeOnClick
            />

            <div className="top_section flex-wrap">
                <div className="pagesNamelink">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            {/* <li className="breadcrumb-item text-white" onClick={handleNewMessage}>Simulate New Message</li> */}
                            <li className="breadcrumb-item"><Link to="/dashboard">{t("admindashboard.dashboard")}</Link></li>
                            <li className="breadcrumb-item text-white">{t("tickets.ticket")}</li>
                        </ol>
                    </nav>
                    <h4 className="text-white">{t("tickets.ticketslist")}</h4>
                </div>
                {
                    isNotCustomer &&
                    <div className='flex gap-4'>
                        <Link to={'/tickets/archivedTickets'} className="delete_btn no-underline"><i className="fa-solid fa-trash me-2"></i>{t("tickets.archivedtickets")}</Link>
                        <Link to={'/tickets/addTicket'} className="main_btn no-underline"><i className="fa-solid fa-plus"></i> {t("tickets.addticket")}</Link>
                    </div>
                }
            </div>
            <div className="mainSection">
                <div className='flex gap-3 align-items-end justify-end mb-3'>
                    <div className="">
                        <button className="add_btn ms-auto" onClick={handleNewMessage}>Allow voice</button>
                    </div>
                    <div className="">
                        <button className="add_btn ms-auto" onClick={() => refetch()} disabled={isLoading || isFetching || isRefetching}>{t("tickets.refresh")} <IoIosRefresh className={`ml-2`} fontSize={'15px'} /> </button>
                    </div>
                    <div className="">
                        <button className="cancel_btn mx-auto" onClick={handleClearFilter}>{t("tickets.clearfilters")}</button>
                    </div>
                </div>

                {!error &&
                    <>
                        <div className="mainTable table-responsive">
                            {isLoading && <Loader />}
                            <form id='filterForm' onSubmit={handleFiltering}>

                                <table id="example" className="table table-striped table-dark">
                                    {!isLoading && !error && TicketsToDisplay &&
                                        <>
                                            <thead>
                                                <tr>
                                                    <th>{t("tickets.ticketid")}</th>
                                                    <th>{t("tickets.alert")}</th>
                                                    {isNotCustomer &&
                                                        <th>{t("tickets.customer")}</th>
                                                    }
                                                    {/* <th>{t("tickets.severity")}</th> */}
                                                    <th style={{ textAlign: "center", verticalAlign: "middle" }} rowSpan="2" data-field="id">
                                                        <div className="th-inner sortable sortable-center both flex flex-row">
                                                            {t("tickets.severity")}
                                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginLeft: '5px' }}>
                                                                <button
                                                                    onClick={(event) => { event.preventDefault(); handleSort('severity') }}
                                                                    aria-label="Sort Severity Ascending"
                                                                    className="btn btn-link p-0 text-white"
                                                                    style={{ fontSize: '10px', lineHeight: '0.5' }}
                                                                >
                                                                    <i className="bi bi-caret-up-fill"></i>
                                                                </button>
                                                                <button
                                                                    onClick={(event) => { event.preventDefault(); handleSort('severity') }}
                                                                    aria-label="Sort Severity Descending"
                                                                    className="btn btn-link p-0 -mt-1 text-white"
                                                                    style={{ fontSize: '10px', lineHeight: '0.5' }}
                                                                >
                                                                    <i className="bi bi-caret-down-fill"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="fht-cell" style={{ width: "95.8281px" }}></div>
                                                    </th>
                                                    {
                                                        isNotCustomer &&
                                                        <th>{t("tickets.analysts")}</th>
                                                    }
                                                    {/* <th>{t("tickets.status")}</th> */}
                                                    <th style={{ textAlign: "center", verticalAlign: "middle" }} rowSpan="2" data-field="id">
                                                        <div className="th-inner sortable sortable-center both flex flex-row">
                                                            {t("tickets.status")}
                                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginLeft: '5px' }}>
                                                                <button
                                                                    onClick={(event) => { event.preventDefault(); handleSort('status') }}
                                                                    aria-label="Sort Severity Ascending"
                                                                    className="btn btn-link p-0 text-white"
                                                                    style={{ fontSize: '10px', lineHeight: '0.5' }}
                                                                >
                                                                    <i className="bi bi-caret-up-fill"></i>
                                                                </button>
                                                                <button
                                                                    onClick={(event) => { event.preventDefault(); handleSort('status') }}
                                                                    aria-label="Sort Severity Descending"
                                                                    className="btn btn-link p-0 -mt-1 text-white"
                                                                    style={{ fontSize: '10px', lineHeight: '0.5' }}
                                                                >
                                                                    <i className="bi bi-caret-down-fill"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="fht-cell" style={{ width: "95.8281px" }}></div>
                                                    </th>
                                                    {isNotAnalyst &&
                                                        // <th>{t("tickets.timestamp")}</th>
                                                        <th style={{ textAlign: "center", verticalAlign: "middle" }} rowSpan="2" data-field="id">
                                                            <div className="th-inner sortable sortable-center both flex flex-row">
                                                                {t("tickets.timestamp")}
                                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginLeft: '5px' }}>
                                                                    <button
                                                                        onClick={(event) => { event.preventDefault(); handleSort('timestamp') }}
                                                                        aria-label="Sort Severity Ascending"
                                                                        className="btn btn-link p-0 text-white"
                                                                        style={{ fontSize: '10px', lineHeight: '0.5' }}
                                                                    >
                                                                        <i className="bi bi-caret-up-fill"></i>
                                                                    </button>
                                                                    <button
                                                                        onClick={(event) => { event.preventDefault(); handleSort('timestamp') }}
                                                                        aria-label="Sort Severity Descending"
                                                                        className="btn btn-link p-0 -mt-1 text-white"
                                                                        style={{ fontSize: '10px', lineHeight: '0.5' }}
                                                                    >
                                                                        <i className="bi bi-caret-down-fill"></i>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div className="fht-cell" style={{ width: "95.8281px" }}></div>
                                                        </th>
                                                    }
                                                    <th>{t("tickets.destinationip")}</th>
                                                    <th>{t("tickets.destinationport")}</th>
                                                    <th>{t("tickets.sourceip")}</th>
                                                    <th>{t("tickets.sourceport")}</th>
                                                    {/* <th>{t("tickets.createdby")}</th> */}
                                                    <th className='w-28'>{t("tickets.actions")}</th>
                                                </tr>

                                            </thead>
                                            <tbody>

                                                <tr>

                                                    <th>
                                                        <input type="text" className="form-control" placeholder={t("tickets.ticketid")} name='ticket_id' />
                                                    </th>
                                                    <th>
                                                        <input type="text" className="form-control" placeholder={t("tickets.alert")} name='alert' />
                                                    </th>
                                                    {
                                                        isNotCustomer &&
                                                        <th>
                                                            <input type="text" className="form-control" placeholder={t("tickets.customer")} name='customer_name' />
                                                        </th>
                                                    }
                                                    <th>
                                                        <select className="form-control" name="severity" value={severity} onChange={handleSeverityChange} >
                                                            <option value="" disabled>Select {t("tickets.severity")}</option>
                                                            <option value="critical">Critical</option>
                                                            <option value="high">High</option>
                                                            <option value="medium">Medium</option>
                                                            <option value="low">Low</option>
                                                            <option value="info">Info</option>
                                                        </select>
                                                    </th>
                                                    {
                                                        isNotCustomer &&
                                                        <th>
                                                            <input type="text" className="form-control" placeholder={t("tickets.analysts")} name='analyst_name' />
                                                        </th>
                                                    }
                                                    <th>
                                                        <select className="form-control" name="status" value={status} onChange={handleStatusChange} >
                                                            <option value="" disabled>Select {t("tickets.status")}</option>
                                                            <option value="opened">Opened</option>
                                                            <option value="pending">Pending</option>
                                                            <option value="resolved">Resolved</option>
                                                            <option value="closed">Closed</option>
                                                        </select>
                                                    </th>
                                                    {isNotAnalyst &&
                                                        <th>
                                                            {/* <input type="text" className="form-control" placeholder={t("tickets.timestamp")} name='timestamp' /> */}
                                                            <DatePicker
                                                                selected={selectedDate}
                                                                onChange={(date) => setSelectedDate(date)}
                                                                showMonthDropdown
                                                                dateFormat="MM/dd/yyyy"
                                                                wrapperClassName='w-full'
                                                                className="form-control"
                                                                placeholderText={t("tickets.timestamp")}
                                                            />
                                                        </th>
                                                    }
                                                    <th>
                                                        <input type="text" className="form-control" placeholder={t("tickets.destinationip")} name='destination_ip' />
                                                    </th>
                                                    <th>
                                                        <input type="text" className="form-control" placeholder={t("tickets.destinationport")} name='dst_port' />
                                                    </th>
                                                    <th>
                                                        <input type="text" className="form-control" placeholder={t("tickets.sourceip")} name='source_ip' />
                                                    </th>
                                                    <th>
                                                        <input type="text" className="form-control" placeholder={t("tickets.sourceport")} name='src_port' />
                                                    </th>
                                                    {/* <th>
                                                        <input type="text" className="form-control" placeholder={t("tickets.createdby")} name='created_by' />
                                                    </th> */}
                                                    <th>
                                                        <button type='submit' className="secondary_btn" disabled={isFiltering ? <Loader /> : ''}>{t("tickets.apply")}</button>
                                                    </th>

                                                </tr>
                                                {TicketsToDisplay.data?.length > 0 && TicketsToDisplay.data?.map((ticket, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>{ticket.ticketId}</td>
                                                            <td style={{ whiteSpace: 'normal', wordWrap: 'break-word', overflowWrap: 'break-word', hyphens: 'auto', maxWidth: '100px' }}>{ticket.alert}</td>
                                                            {
                                                                isNotCustomer &&
                                                                <td style={{ whiteSpace: 'normal', wordWrap: 'break-word', overflowWrap: 'break-word', hyphens: 'auto', maxWidth: '100px' }}>{ticket.customer_first_name + " " + ticket.customer_last_name}</td>
                                                            }
                                                            <td>
                                                                <div className={`sevBtn Sev${ticket.severity} capitalize`}>{ticket.severity}</div>
                                                            </td>
                                                            {isNotCustomer &&
                                                                <td style={{ whiteSpace: 'normal', wordWrap: 'break-word', overflowWrap: 'break-word', hyphens: 'auto', maxWidth: '100px' }}>{ticket.analyst_first_name + " " + ticket.analyst_last_name}</td>
                                                            }
                                                            <td className={`status${(ticket.status).charAt(0).toUpperCase() + ticket.status.slice(1)} capitalize`}>{ticket.status}</td>
                                                            {isNotAnalyst &&
                                                                <td style={{ whiteSpace: 'normal', wordWrap: 'break-word', overflowWrap: 'break-word', hyphens: 'auto', maxWidth: '100px' }}>{format(new Date(ticket.timestamp), "MM/dd/yyyy hh:mm a")}</td>
                                                            }
                                                            <td style={{ whiteSpace: 'normal', wordWrap: 'break-word', overflowWrap: 'break-word', hyphens: 'auto', maxWidth: '100px' }}>{ticket.destination_ip}</td>
                                                            <td style={{ whiteSpace: 'normal', wordWrap: 'break-word', overflowWrap: 'break-word', hyphens: 'auto', maxWidth: '100px' }}>{ticket.dst_port}</td>
                                                            <td style={{ whiteSpace: 'normal', wordWrap: 'break-word', overflowWrap: 'break-word', hyphens: 'auto', maxWidth: '100px' }}>{ticket.source_ip}</td>
                                                            <td style={{ whiteSpace: 'normal', wordWrap: 'break-word', overflowWrap: 'break-word', hyphens: 'auto', maxWidth: '100px' }}>{ticket.src_port}</td>
                                                            {/* <td>{ticket.created_by}</td> */}
                                                            <td>

                                                                <div className="actionBtn flex justify-between gap-2 items-center w-max">
                                                                    {userType === "super_admin" || userType === "admin" || userType === "analyst" ? (
                                                                        <div className="form-check">
                                                                            <input
                                                                                style={{ backgroundColor: `${ticket.isCritical ? '#B10606' : ''}` }}
                                                                                type="checkbox"
                                                                                className={`form-check-input fs-5`}
                                                                                id={`criticalCheckbox-${ticket.ticket_uuid}`}
                                                                                checked={ticket.isCritical}
                                                                                onChange={() => toggleCritical(ticket.ticket_uuid, ticket.isCritical)}
                                                                                aria-label={`Mark ticket ${ticket.ticket_uuid} as critical`}
                                                                                title={ticket.isCritical ? "Deception AI mode inactive" : "Deception AI mode active"}
                                                                                disabled={loadingTicketId !== null} // Disable if any ticket is being processed
                                                                            />
                                                                            {loadingTicketId === ticket.ticket_uuid && <Loader />}{/* Show loader only for the loading ticket */}
                                                                        </div>
                                                                    ) : ""}

                                                                    {/* Existing buttons */}
                                                                    {/* Other existing components like ChatModal, Call, etc. */}






                                                                    <button type='button' className="view" data-bs-toggle="modal" data-bs-target="#view" onClick={() => setViewTicketID(ticket.ticket_uuid)}>
                                                                        <img src={ViewIcon} alt="View" />
                                                                    </button>
                                                                    <Link to={`/tickets/editTicket/${ticket.ticket_uuid}`} className="Edit m-0">
                                                                        <img src={EditIcon} alt="Edit" />
                                                                    </Link>

                                                                    <button type='button' className="Delete" onClick={() => deleteTicketalert(ticket.ticket_uuid)}>
                                                                        <img src={DeleteIcon} alt="Delete" />
                                                                    </button>

                                                                    <div className="relative" onClick={() => toggleModal(ticket)} id={ticket.ticketId}>
                                                                        <IoIosChatbubbles className="text-blue-500 cursor-pointer text-2xl" />
                                                                        {(ticket.notificationCount1 > 0 && ticket.chatUserType !== userInfo.user_type) && !isOpen && (
                                                                            <span className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs animate-pulse cursor-pointer">
                                                                                {ticket.notificationCount1}
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                    <ChatModal isOpen={isOpen} onClick={() => toggleModal(ticketDatas)} chatId={chatId} ticket={ticketDatas} />
                                                                    <Call analist={ticket.analyst_phone} customer={ticket.customer_phone} ticketid={ticket.ticketId} />
                                                                    {(userType === "super_admin" || userType === "admin") && (
                                                                        <Link to={`/tickets/viewCallRecording/${ticket.ticket_uuid}`} className="Edit m-0">
                                                                            <FaFileAudio />
                                                                        </Link>
                                                                    )}
                                                                </div>
                                                            </td>
                                                        </tr>

                                                    );
                                                })}
                                                {TicketsToDisplay.data.length === 0 && <p className='text-center text-white mt-4'>No matching results found !</p>}

                                            </tbody>
                                        </>
                                    }
                                    {/* {!isLoading && ticketsToDisplay.data.length == 0 ? <p className='text-center text-white mt-4'>No matching results found !</p>:''} */}
                                </table>
                            </form>


                        </div>
                        {
                            TicketsToDisplay.data.length > 0 &&
                            <div>
                                <Pagination
                                    itemsPerPage={10}
                                    totalItems={TicketsToDisplay?.pagination?.totalItems}
                                    paginate={paginate}
                                    currPage={currentPage}
                                />
                            </div>
                        }
                    </>
                }
                {error &&
                    <p className='text-center text-white mt-4'>Something went wrong. Please try again later !</p>
                }
            </div >

            {/* <!--View Modal --> */}
            < ViewModal token={token} id={viewTicketID} userInfo={userInfo} />

        </>
    )
}


const ViewModal = ({ token, id, userInfo }) => {
    const { data: ticket, isLoading, error } = useQuery({ queryKey: ['ticket', id], queryFn: () => getTicket(token, id), enabled: id ? true : false })
    return (
        <div className="modal fade viewModel" id="view" tabIndex="-1" aria-labelledby="viewLabel" aria-hidden="true">
            <div className="modal-dialog modal-xl modal-dialog-centered">
                <div className="modal-content text-wrap">
                    <div className="modal-header">
                        <h5 className="modal-title" id="viewLabel">{t("viewticket.viewticket")}</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="viewTicket row g-3">
                            {isLoading && <Loader />}

                            {ticket &&
                                <>
                                    <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                        <h6>{t("viewticket.alert")}</h6>
                                        <p>{ticket.data?.alert}</p>
                                    </div>
                                    <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                        <h6>{t("viewticket.alerttype")}</h6>
                                        <p>{ticket.data?.alert_type}</p>
                                    </div>
                                    <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                        <h6>{t("viewticket.severity")}</h6>
                                        <p className="statusClosed">{ticket.data?.severity}</p>
                                    </div>
                                    <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                        <h6>{t("viewticket.customer")}</h6>
                                        <p>{ticket.data.customer_first_name + ' ' + ticket.data?.customer_last_name}</p>
                                    </div>
                                    <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                        <h6>{t("viewticket.assignto")}</h6>
                                        <p>{ticket.data.analyst_first_name + ' ' + ticket.data?.analyst_last_name}</p>
                                    </div>
                                    <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                        <h6>{t("viewticket.sourceip")}</h6>
                                        <p style={{ wordBreak: 'break-all', }}>{ticket.data.source_ip} | {ticket.data?.src_port}</p>
                                    </div>
                                    <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                        <h6>{t("viewticket.destinationip")}</h6>
                                        <p style={{ wordBreak: 'break-all', }}>{ticket.data.destination_ip} | {ticket.data?.dst_port}</p>
                                    </div>
                                    <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                        <h6>{t("viewticket.timestamp")} </h6>
                                        <p>{format(ticket.data?.timestamp, "MM/dd/yyyy hh:mm a")}</p>
                                    </div>
                                    <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                        <h6>{t("viewticket.status")}</h6>
                                        <p className="statusProgress">{ticket.data?.status}</p>
                                    </div>
                                    <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                        <h6>{t("viewticket.processnamefilename")}</h6>
                                        <p className="statusProgress">{ticket.data?.fileName}</p>
                                    </div>
                                    <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                        <h6>{t("viewticket.domain")}</h6>
                                        <p className="statusProgress">{ticket.data?.domain}</p>
                                    </div>
                                    <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                        <h6>{t("viewticket.attachments")}</h6>
                                        <div className='flex flex-wrap items-center gap-x-4'>
                                            {ticket.data.attachments.length > 0 ? (
                                                ticket.data.attachments.map((file, i) => (
                                                    <span className='UploadedFile m-0' key={i}>
                                                        {['super_admin', 'admin', 'analyst', 'customer', 'secondary_customer'].includes(userInfo?.user_type) ? (
                                                            <a
                                                                href={`${attachmentURL}/uploads/${file.filename}`}
                                                                target='_blank'
                                                                rel="noopener noreferrer"
                                                                className="text-blue-600 underline"
                                                            >
                                                                {file?.originalname}
                                                            </a>
                                                        ) : (
                                                            <span className="text-gray-500">{file?.originalname}</span> // Non-clickable for others
                                                        )}
                                                    </span>
                                                ))
                                            ) : (
                                                <p>No attachments</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                        <h6>{t("viewticket.virustotallink")}</h6>
                                        <a href={ticket.data.virus_total_link} target='_blank' rel="noreferrer" className="linkFile">
                                            {ticket.data?.virus_total_link}
                                        </a>
                                    </div>
                                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                        <h6>{t("viewticket.abuseddblink")}</h6>
                                        <a href={ticket.data.abuse_db_link} target='_blank' rel="noreferrer" className="linkFile">
                                            {ticket.data?.abuse_db_link}
                                        </a>
                                    </div>
                                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                        <h6>{t("viewticket.filehash")}</h6>
                                        <p>
                                            {ticket.data?.fileHash}
                                        </p>
                                    </div>
                                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                        <h6>Created By</h6>
                                        <p>
                                            {ticket.data?.created_by}
                                        </p>
                                    </div>
                                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                        <h6>Summary</h6>
                                        <p>{ticket.data?.summary}</p>
                                    </div>
                                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                        <h6>{t("viewticket.customersummary")}</h6>
                                        <p>{ticket.data?.customer_summary}</p>
                                    </div>
                                </>
                            }
                            {error && <p>{t("viewticket.somethingwentwrong")}</p>}

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}

export default TicketList;